import client from '../../client';

const endpoint = '/v2/global/seller-homologations';


/**
 * Get all the seller-homologations from the backend.
 * For more information please read the backend docs.
 */
export function getAll() {
  return client.get(endpoint).then(({ data }) => data)
}

export default {
  getAll,
}
